<h5 class="dropdown-wrapper-header" [class.dark]="dark" *ngIf="title">{{ title }}</h5>
<div (clickOutside)="closeWhenClickedOutside($event)" [class.error]="error"  class="dropdown-wrapper" [class.dark]="dark">
  <button (click)="onToggle()" [class.disabled]="disabled" [class.dark]="dark">
    <span *ngIf="!inputValue && placeholder; else displayInputValue">{{ placeholder }}</span>
    <ng-template #displayInputValue>
    <input [disabled]="disabled" [placeholder]="placeholder" [readOnly]="true" [value]="inputValue" autocomplete="nope" #input>
    </ng-template>
    <div class="dropdown-arrow">
      <img [class]="menuStatus ? 'up-arrow' : 'down-arrow'" />
    </div>
  </button>
  <div *ngIf="menuStatus" class="dropdown-area">
    <ng-template
      *ngTemplateOutlet="nestedDropdown; context: {options} ">
    </ng-template>
  </div>
</div>

<ng-template #nestedDropdown let-options="options">
  <ng-container *ngFor="let option of options">
    <div class="dropdown-button">
      <button
        [class.selected]="isOptionSelected(option.name)"
        [disabled]="option.disabled"
        (click)="onSelect(option)"
      >
        {{ option.name }}
      </button>
      <div
        *ngIf="option.innerGroups.length"
        (click)="onToggle(option)"
        stopClickPropagation
        class="dropdown-arrow"
        [style]="option.innerGroups.length ? 'border-left: 2px solid white' : ''"
      >
        <img [class]="option.status ? 'up-arrow' : 'down-arrow'" />
      </div>
    </div>
    <div *ngIf="option.innerGroups.length && option.status" class="dropdown_inner">
      <ng-template
        *ngTemplateOutlet="nestedDropdown; context: {options: option.innerGroups} ">
      </ng-template>
    </div>
  </ng-container>
</ng-template>
